import { Box } from '@mui/material';
import { memo, useMemo } from 'react';
import ProductGridInput from '../../../../../../../../components/ProductGridInput/ProductGridInput';
import { GridItem } from '../../../../../../../../components/ProductGridInput/types/productGridInput.types';
import { useRachelChangedValue } from '../../../../../../../rachel/hooks/useRachelChangedValue';
import useProductInput from '../hooks/useProductInput';
import { ProductInputProps } from '../types/productInput.types';

const ProductInput = ({ gridItem, suggestedGridItem }: ProductInputProps) => {
  const {
    disabled,
    showStock,
    stockValue,
    maxValue,
    quantity,
    inputRef,
    textInputProps,
    hasTouchLayout,
    isReadOnly,
    productColorAvailability,
    tooltipMessage,
  } = useProductInput({
    gridItem,
    suggestedGridItem,
  });

  const { className: rachelClassName } = useRachelChangedValue(quantity, { appearance: 'input' });

  const formattedGridItem: GridItem = useMemo(
    () => ({
      ...gridItem,
      sizeName: gridItem.productSizeName,
      sizeActive: gridItem.productSizeActive,
      sizeUnique: gridItem.productSizeUnique,
      sizePosition: gridItem.productSizePosition,
      quantity: quantity,
      availableAmount: gridItem.stock?.availableAmount ?? null,
    }),
    [gridItem, quantity],
  );

  return (
    <Box className={rachelClassName}>
      <ProductGridInput
        maxValue={maxValue}
        stock={stockValue}
        disabled={disabled}
        showStock={showStock}
        hasTouchLayout={hasTouchLayout}
        isReadOnly={isReadOnly}
        inputRef={inputRef}
        gridItem={formattedGridItem}
        textFieldProps={textInputProps}
        productColorAvailability={productColorAvailability}
        tooltipMessage={tooltipMessage}
      />
    </Box>
  );
};

export default memo(ProductInput);
